<template>
  <div>
    <p class="text-truncate">{{ $filters.truncate(content, charsToShow) }}</p>
    <a v-if="shouldTruncate" @click.prevent="expandResult">Show
      <span v-if="!expanded">More <i class="fa fa-caret-down"></i></span>
      <span v-if="expanded">Less <i class="fa fa-caret-up"></i></span>
    </a>
  </div>
</template>

<script>
  export default {
    computed: {
      shouldTruncate() {
        return this.content.length > this.limit;
      }
    },
    props: {
      limit: Number,
      text: String
    },
    data() {
      return {
        expanded: false,
        charsToShow: this.limit,
        content: this.text !== null ? this.text : ''
      };
    },
    methods: {
      expandResult() {
        this.expanded = !this.expanded;

        // Show everything if now expanded
        this.charsToShow = this.expanded ? this.content.length : this.limit;
      }
    }
  };
</script>
